'use client';

import { useEffect } from 'react';

export function GTMDataLayer({ data }: { data: Record<string, unknown> }) {
  useEffect(() => {
    window.dataLayer?.push(data);
  }, [data]);

  return null;
}
